var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import './QuickAdd.scss';
import classNames from 'classnames';
import { COPY_GENERIC } from '@sonar-software/sonar-ts-constants';
import { Button } from 'antd';
import { InlineInputForm } from './InlineInputForm';
import React, { useEffect } from 'react';
import { useBoolean, useCurrentUser, usePrevious } from '@hooks';
export const QuickAdd = (_a) => {
    var { form, inputProps, noPadding, processing, toggleProps, typeLabel } = _a, rest = __rest(_a, ["form", "inputProps", "noPadding", "processing", "toggleProps", "typeLabel"]);
    const { isReadOnly } = useCurrentUser();
    const [isEditing, setIsEditing] = useBoolean();
    const previousProcessing = usePrevious(processing, false);
    useEffect(() => {
        if (previousProcessing && !processing) {
            setIsEditing.off();
        }
    }, [previousProcessing, processing, setIsEditing]);
    if (isReadOnly) {
        return null;
    }
    if (!isEditing) {
        return (React.createElement("div", { className: classNames('quick-add-button-wrapper', { 'no-padding': noPadding }) },
            React.createElement(Button, Object.assign({ id: 'quick-add-button' }, toggleProps, { onClick: setIsEditing.on, type: 'primary' }), COPY_GENERIC.CREATE_NEW(typeLabel))));
    }
    if (form) {
        const CustomFormComponent = form;
        return React.createElement(CustomFormComponent, Object.assign({ onCancel: setIsEditing.off }, rest));
    }
    const modifiedInputProps = Object.assign({ placeholder: COPY_GENERIC.NAME_YOUR(typeLabel) }, inputProps);
    return (React.createElement(InlineInputForm, Object.assign({ inputProps: modifiedInputProps, noPadding: noPadding, onCancel: setIsEditing.off }, rest)));
};
